import React from 'react';
import Menu from './Menu';
import UserInfo from '../modules/user/UserInfo';
import {connect} from "react-redux";
import DiscLogo from "./DiscLogo";
import {
    getAllergenReactionTypes,
    getAllergenTypes,
    getAllergySeverityTypes,
    getAllergyTypes,
    getCountries,
    getLanguages,
    getMaritalStatuses,
    getNationalities,
    getProfessions,
    getRelationshipTypes,
    getReligions
} from "../services/actions";

class Header extends React.Component {

    componentDidMount() {
        this.appInit();
    }

    appInit = () => {
        this.props.dispatch(getNationalities());
        this.props.dispatch(getCountries());
        this.props.dispatch(getRelationshipTypes());
        this.props.dispatch(getLanguages());
        this.props.dispatch(getProfessions());
        this.props.dispatch(getReligions());
        this.props.dispatch(getMaritalStatuses());
        this.props.dispatch(getAllergyTypes());
        this.props.dispatch(getAllergenTypes());
        this.props.dispatch(getAllergySeverityTypes());
        this.props.dispatch(getAllergenReactionTypes());
    };

    render() {
        const user = this.props.user && this.props.user.token;
        return (
            <>
            <div className="Header">
                <DiscLogo/>
                <div  className={"d-none d-xl-flex col"}>
                  {user && <Menu/>}
                </div>
                {user && <UserInfo/>}
            </div>
                <div className="d-xl-none d-flex">
                      {user && <Menu/>}
                </div>
            </>
        )
    }

}

const mapStateToProps = state => {
    return {
        user: state.authentication.user
    };
};

export default connect(mapStateToProps)(Header);
